/**
 * Fix double-encoded HTML entities in UnLayer's exported HTML.
 *
 * UnLayer's exportHtml double-encodes HTML entities in href attributes,
 * turning `"` into `&quot;` and then `&amp;quot;` in the final output.
 * This breaks survey JWT URLs which contain JSON with quotes.
 *
 * This function decodes `&amp;quot;` back to `"` within href attributes
 * so the backend can parse the JWT payload correctly.
 */
export function fixUnlayerHtmlEntities(html: string): string {
  // Match href="..." attributes and decode &amp;quot; -> " within them
  return html.replace(/href="([^"]*)"/g, (match, hrefValue: string) => {
    const fixed = hrefValue.replace(/&amp;quot;/g, '"');
    if (fixed === hrefValue) return match;
    return `href="${fixed}"`;
  });
}
